import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const shipmentStatus = v.union(
  v.literal("open"),
  v.literal("in_transit"),
  v.literal("delivered"),
);

export const validatorShipment = v.object({
  name: v.string(),
  shipmentType: v.union(v.literal("air"), v.literal("sea"), v.literal("land")),
  status: shipmentStatus,
  containerId: v.optional(v.id("containers")),
  calendarId: v.optional(v.id("consolidation_calendars")),
  shippingRouteId: v.optional(v.id("shipping_routes")),
  carrierId: v.optional(v.id("carriers")),
  estimatedDepartureDate: v.optional(v.number()),
  estimatedArrivalDate: v.optional(v.number()),
  actualDepartureDate: v.optional(v.number()),
  actualArrivalDate: v.optional(v.number()),
  autoCloseDate: v.optional(v.number()),
  closedAt: v.optional(v.number()),
  totalPackages: v.number(),
  totalVolumeCF: v.number(),
  totalWeight: v.number(),
  totalRevenue: v.number(),
  totalExcessCF: v.number(),
  notes: v.optional(v.string()),
  internalControl: internalControl,
});

export const shipments = defineTable(validatorShipment)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_status", ["status"])
  .index("by_name", ["name"])
  .index("by_company_and_name", ["internalControl.companyId", "name"])
  .index("by_shipping_route", ["shippingRouteId"])
  .index("by_carrier", ["carrierId"])
  .index("by_auto_close_date", ["autoCloseDate"])
  .index("by_container", ["containerId"])
  .index("by_calendar", ["calendarId"])
  .index("by_company_and_calendar", ["internalControl.companyId", "calendarId"])
  .searchIndex("search_shipments", {
    searchField: "name",
    filterFields: [
      "internalControl.companyId",
      "internalControl.state",
      "status",
    ],
  });
